const provSpecialties = [
  {
    name: 'chongqing',
    top: '15.5vw',
    left: '23.2vw',
    value: ['巫山脆李', '奉节脐橙', '忠县大米', '涪陵榨菜', '石柱辣椒', '城口老腊肉'],
    title: '重庆'
  },
  {
    name: 'zhejiang',
    top: '17vw',
    left: '32vw',
    value: ['浦江葡萄', '常山胡柚', '湖州大米', '宁波大米', '浙江嘉兴糯米', '绍兴料酒', '杭州坚果', '台州大陈黄鱼', '仙居杨梅'],
    title: '浙江'
  },
  {
    name: 'yunnan',
    top: '20.5vw',
    left: '18.5vw',
    value: ['云南会泽软籽石榴', '云南高原大米', '曲靖罗平菜籽油', '云南普洱茶', '文山三七'],
    title: '云南'
  },
  {
    name: 'xinjiang',
    top: '7.5vw',
    left: '8vw',
    value: ['新疆哈密瓜', '昌吉奇台面粉', '新疆干果', '新疆牛羊肉'],
    title: '新疆'
  },
  {
    name: 'xizang',
    top: '14.5vw',
    left: '8vw',
    value: ['西藏食用菌', '西藏农品'],
    title: '西藏'
  },
  {
    name: 'sichuan',
    top: '15.5vw',
    left: '19vw',
    value: ['汉源甜樱桃', '攀枝花芒果', '盐源苹果', '四川柑橘', '都江堰猕猴桃', '乐山大米', '天府香油', '自贡腊味'],
    title: '四川'
  },
  {
    name: 'shanghai',
    top: '15vw',
    left: '33vw',
    value: ['上海农品'],
    title: '上海'
  },
  {
    name: 'shaanxi',
    top: '13vw',
    left: '23.5vw',
    value: ['铜川大樱桃', '大荔冬枣', '洛川苹果', '白水苹果', '旬邑苹果', '眉县猕猴桃', '周至猕猴桃', '汉中五彩米', '安康茶叶', '洛南扶贫农产品'], // 陕西
    title: '陕西'
  },
  {
    name: 'shanxi',
    top: '10.5vw',
    left: '25.5vw',
    value: ['吉县苹果', '隰县玉露香梨', '运城面粉', '长治小米', '吕粮山猪'], // 山西
    title: '山西'
  },
  {
    name: 'shandong',
    top: '11vw',
    left: '31vw',
    value: ['章丘大葱', '胶东大樱桃', '烟台苹果', '齐鲁香瓜', '蒙阴蜜桃', '齐鲁蔬菜', '黄河口大米', '齐鲁面粉', '微山湖生态农品', '齐鲁花生', '胶东海鲜', '山东生态鸡蛋'],
    title: '山东'
  },
  {
    name: 'qinghai',
    top: '10.5vw',
    left: '12.5vw',
    value: ['青海高原藜麦', '西宁菜籽油', '青海蜂蜜', '青海牛羊肉'],
    title: '青海'
  },
  {
    name: 'ningxia',
    top: '10.5vw',
    left: '21.5vw',
    value: ['中宁枸杞', '盐池滩羊'],
    title: '宁夏'
  },
  {
    name: 'neimenggu',
    top: '8vw',
    left: '22.5vw',
    value: ['内蒙古土豆', '内蒙古白面', '兴安盟大米', '内蒙古食用油', '锡盟羊肉', '内蒙古牛肉'],
    title: '内蒙古'
  },
  {
    name: 'liaoning',
    top: '8vw',
    left: '33vw',
    value: ['辽阳辽峰葡萄', '大连樱桃', '丹东草莓', '盘锦大米', '朝阳食用油', '铁岭山珍', '锦州闾山鸡蛋', '辽南海产品'],
    title: '辽宁'
  },
  {
    name: 'jiangxi',
    top: '18vw',
    left: '28.5vw',
    value: ['赣南脐橙', '上饶马家柚', '吉安井冈大米', '萍乡紫红米', '井冈茶油', '广昌白莲'],
    title: '江西'
  },
  {
    name: 'jiangsu',
    top: '13.5vw',
    left: '31.5vw',
    value: ['江苏水蜜桃', '徐州大沙河苹果', '盐城射阳大米', '泗洪大米', '江苏大闸蟹', '高邮鸭基地', '连云港海产品'],
    title: '江苏'
  },
  {
    name: 'jilin',
    top: '7vw',
    left: '35.5vw',
    value: ['松原黄小米', '吉林大米', '吉林杂粮', '吉林大豆油', '吉林黄金玉米', '长白山山珍', '长白山人参', '双阳梅花鹿', '长白山木耳', '吉林省桦甸黄牛', '松原查干湖鱼'],
    title: '吉林'
  },
  {
    name: 'hunan',
    top: '18vw',
    left: '26vw',
    value: ['石门柑橘', '汝城奈李', '湘潭湘莲', '炎陵黄桃', '湘西猕猴桃', '麻阳冰糖橙', '江永香柚', '汉寿香米', '隆回金银花', '衡阳黄花菜', '岳阳洞庭湖小龙虾'],
    title: '湖南'
  },
  {
    name: 'heilongjiang',
    top: '3.5vw',
    left: '35vw',
    value: ['佳木斯大米', '鸡西大米', '黑龙江大米', '齐齐哈尔面粉', '绥化甜糯玉米', '齐齐哈尔玉米油', '牡丹江山珍'],
    title: '黑龙江'
  },
  {
    name: 'henan',
    top: '12.8vw',
    left: '26.8vw',
    value: ['西峡猕猴桃', '荥阳河阴石榴', '寺河山苹果', '温县四大怀药', '新郑大枣', '宁陵酥梨', '原阳大米', '商丘富硒面粉', '安阳红旗渠杂粮', '百全食用油', '豫东十宝', '魏都三珍', '驻马店嵖岈山山珍', '平顶山郏县红牛'],
    title: '河南'
  },
  {
    name: 'hebei',
    top: '10.5vw',
    left: '27.5vw',
    value: ['石家庄雪花梨', '保定五谷', '丰南大米', '唐山蟹田大米', '廊坊大豆油', '邯郸花生', '河北板栗', '秦皇岛山珍'],
    title: '河北'
  },
  {
    name: 'hubei',
    top: '15vw',
    left: '26vw',
    value: ['宜昌柑橘', '孝感大米', '荆楚香稻', '荆门粮油', '湖北茶叶', '湖北特色淡水虾蟹', '仙桃鸭蛋'],
    title: '湖北'
  },
  {
    name: 'hainan',
    top: '24.5vw',
    left: '25vw',
    value: ['三亚芒果', '三门坡荔枝', '文昌椰青'],
    title: '海南'
  },
  {
    name: 'guizhou',
    top: '18vw',
    left: '21.5vw',
    value: ['威宁冰心苹果', '六盘水猕猴桃', '贵州刺梨', '贵州省兴仁薏仁米', '锦屏茶油', '遵义辣椒'],
    title: '贵州'
  },
  {
    name: 'guangxi',
    top: '21vw',
    left: '24.8vw',
    value: ['广西柳州金桔', '南宁火龙果', '百色芒果', '南宁沃柑', '平南石峡龙眼', '玉林沙田柚', '南宁宾阳古辣香米', '恭城月柿'],
    title: '广西'
  },
  {
    name: 'guangdong',
    top: '21vw',
    left: '27.5vw',
    value: ['徐闻菠萝', '茂名荔枝', '梅州柚子', '新会陈皮', '英德红茶', '南澳海产品'],
    title: '广东'
  },
  {
    name: 'gansu',
    top: '9vw',
    left: '16vw',
    value: ['天水大樱桃', '花牛苹果', '甘肃蜜瓜', '兰州百合', '甘肃牛羊肉'],
    title: '甘肃'
  },
  {
    name: 'fujian',
    top: '19vw',
    left: '31vw',
    value: ['福建桔柚', '福建茶叶', '宁德食用菌', '古田银耳', '福建海产品', '福州鱼丸'],
    title: '福建'
  },
  {
    name: 'beijing',
    top: '8.5vw',
    left: '28vw',
    value: ['平谷大桃', '京郊苹果'],
    title: '北京'
  },
  {
    name: 'anhui',
    top: '15vw',
    left: '30vw',
    value: ['砀山酥梨', '江南米市', '皖美油脂', '皖美坚果', '黄山茶叶', '大别山茶叶', '大别山山珍', '亳州花草茶', '皖北肉制品', '江淮水产品'],
    title: '安徽'
  },
  {
    name: 'tianjin',
    top: '8.8vw',
    left: '29.5vw',
    value: ['天津沙窝萝卜', '津南小站稻'],
    title: '天津'
  },
]

 export { provSpecialties }



// WEBPACK FOOTER //
// ./src/util/localData.js